import React from 'react';

import Button from '../../../components/ui/Button';

const DrillDownModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-1030 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg border border-border shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-4 md:p-6 border-b border-border flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-1">
              Transaction Details: {data?.account}
            </h3>
            <p className="caption text-muted-foreground">
              Total: {data?.amount}
            </p>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px]">
              <thead className="bg-muted">
                <tr>
                  <th className="px-4 py-3 font-body font-semibold text-xs md:text-sm text-foreground text-left">
                    Date
                  </th>
                  <th className="px-4 py-3 font-body font-semibold text-xs md:text-sm text-foreground text-left">
                    Description
                  </th>
                  <th className="px-4 py-3 font-body font-semibold text-xs md:text-sm text-foreground text-left">
                    Reference
                  </th>
                  <th className="px-4 py-3 font-body font-semibold text-xs md:text-sm text-foreground text-right">
                    Debit
                  </th>
                  <th className="px-4 py-3 font-body font-semibold text-xs md:text-sm text-foreground text-right">
                    Credit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {data?.transactions?.map((transaction, index) => (
                  <tr key={index} className="hover:bg-muted/50 transition-smooth">
                    <td className="px-4 py-3 font-body text-sm text-foreground whitespace-nowrap">
                      {transaction?.date}
                    </td>
                    <td className="px-4 py-3 font-body text-sm text-foreground">
                      {transaction?.description}
                    </td>
                    <td className="px-4 py-3 font-body text-sm text-muted-foreground">
                      {transaction?.reference}
                    </td>
                    <td className="px-4 py-3 font-body text-sm text-right data-text">
                      {transaction?.debit || '-'}
                    </td>
                    <td className="px-4 py-3 font-body text-sm text-right data-text">
                      {transaction?.credit || '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-4 md:p-6 border-t border-border flex justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            variant="default"
            iconName="FileDown"
            iconPosition="left"
          >
            Export Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DrillDownModal;